import '../../styles/bitacora.style.css'
import {useDispatch, useSelector} from 'react-redux'
import BasicCardDocumentos from '../DatosDeCierre/BasicCardDocumentos'
import ModalCargarFileCompras from '../LibroCompras/ModalCargarFileCompras'
import { State } from '../../../../reducers'
import { useHistory } from 'react-router'
import { useEffect, useState } from 'react'
import { Pagination } from '../../../../components/Pagination';
import { postCargarLibrosCompras } from '../../../../actions/libros/libro-compras.actions'
import FilterButton from '../../../../components/Tables/TableComponent/FilterButton'

const TableDataCargadaCompras = () => {
  const {comprasFileDataCargada} = useSelector((state: State) => state.libros);
  const {dataFile, form, fileBase64} = comprasFileDataCargada;

  const [modalCargarFile, setModalCargarFile] = useState<boolean> (false);
  const [currentItems, setCurrentItems] = useState<Array<any>>([]);
  const [sortedArray, setSortedArray] = useState<Array<any>>([]);

  const dispatch = useDispatch();
  const history = useHistory();
  
  const handleCrearLibro = async () => {
    if (await dispatch(postCargarLibrosCompras(form, fileBase64))) {
      history.push('/mas-opciones/libro-compras');
    }
  }

  useEffect(() => {
    setSortedArray(currentItems);
  }, [currentItems]);

  return (
    <>
      { 
        modalCargarFile
        && <ModalCargarFileCompras onAccept={() => setModalCargarFile(false)} onClose={() => setModalCargarFile(false)} />
      }
      <div className="w-layout-layout bill-section wf-layout-layout">
        <BasicCardDocumentos 
          style={{boxShadow: 'none', padding: '0'}} 
          title="Validar datos" 
          size="l"
        >
          <div style={{display: 'flex', justifyContent: 'start', marginTop: '8px', marginBottom: '16px' }}>
            <button className="button w-auto" onClick={() => setModalCargarFile(true)}>Cargar nuevo libro de compras</button>
          </div>
          <div className="tab-plane">
            <div className="table-facturacion-resp">
              <table className="table-main-responsive responsive-table-main td-left table-pointer">
                <thead>
                  <tr>
                    <td>No. <FilterButton keyName='numCorrelativo' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Fecha Emisión <FilterButton keyName='fechaEmision' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Número Comprobante <FilterButton keyName='numeroComprobante' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>NIT Provedor <FilterButton keyName='nitProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Número Registro <FilterButton keyName='nrcProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>DUI Proveedor <FilterButton keyName='duiProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Nombre Proveedor <FilterButton keyName='nombreProveedor' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    
                    <td>Número Control <FilterButton keyName='numeroControl' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Código Generación <FilterButton keyName='codigoGeneracion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Sello Recepción <FilterButton keyName='selloRecepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Tipo Operación <FilterButton keyName='tipoOperacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Clasificación <FilterButton keyName='clasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Tipo Costo/Gasto <FilterButton keyName='tipoClasificacion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Sector <FilterButton keyName='sector' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    
                    <td>Exentas Locales <FilterButton keyName='exentasLocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Exentas Importaciones <FilterButton keyName='exentasImportaciones' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Exentas Internacionales <FilterButton keyName='exentasInternacionales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Locales <FilterButton keyName='gravadasLocales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Importaciones <FilterButton keyName='gravadasImportaciones' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Importaciones Servicios <FilterButton keyName='gravadasImportacionesServicios' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Gravadas Internacionales <FilterButton keyName='gravadasInternacionales' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Crédito Fiscal IVA <FilterButton keyName='creditoFiscalIva' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Total Compras <FilterButton keyName='totalCompras' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Percepción <FilterButton keyName='percepcion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                    <td>Retención <FilterButton keyName='retencion' data={sortedArray} state={(items: Array<any>) => setSortedArray(items)}/></td>
                  </tr>
                </thead>
                <tbody>
                  {
                    sortedArray?.length > 0 && 
                    (
                      sortedArray.map((item: any) => (
                        <tr key={item.numCorrelativo}>
                          <td data-label='No.'>{item.numCorrelativo}</td>
                          <td data-label='Fecha Emisión'>{item.fechaEmision}</td>
                          <td data-label='Número Comprobante'>{item.numeroComprobante}</td>
                          <td data-label='NIT Proveedor'>{item.nitProveedor}</td>
                          <td data-label='Número Registro'>{item.nrcProveedor}</td>
                          <td data-label='DUI Proveedor'>{item.duiProveedor}</td>
                          <td data-label='Nombre Proveedor'>{item.nombreProveedor}</td>
                          
                          <td data-label='Número Control'>{item.numeroControl}</td>
                          <td data-label='Código Generación'>{item.codigoGeneracion}</td>
                          <td data-label='Sello Recepción'>{item.selloRecepcion}</td>
                          <td data-label='Tipo Operación'>{item.tipoOperacion}</td>
                          <td data-label='Clasificación'>{item.clasificacion}</td>
                          <td data-label='Tipo Costo/Gasto'>{item.tipoClasificacion}</td>
                          <td data-label='Sector'>{item.sector}</td>

                          <td data-label='Exentas Locales'>{parseFloat(item.exentasLocales).toFixed(2)}</td>
                          <td data-label='Exentas Importaciones'>{parseFloat(item.exentasImportaciones).toFixed(2)}</td>
                          <td data-label='Exentas Internacionales'>{parseFloat(item.exentasInternacionales).toFixed(2)}</td>
                          <td data-label='Gravadas Locales'>{parseFloat(item.gravadasLocales).toFixed(2)}</td>
                          <td data-label='Gravadas Importaciones'>{parseFloat(item.gravadasImportaciones).toFixed(2)}</td>
                          <td data-label='Gravadas Importaciones Servicios'>{parseFloat(item.gravadasImportacionesServicios).toFixed(2)}</td>
                          <td data-label='Gravadas Internacionales'>{parseFloat(item.gravadasInternacionales).toFixed(2)}</td>
                          <td data-label='Crédito Fiscal IVA'>{parseFloat(item.creditoFiscalIva).toFixed(2)}</td>
                          <td data-label='Total Compras'>{parseFloat(item.totalCompras).toFixed(2)}</td>
                          <td data-label='Percepción'>{parseFloat(item.percepcion).toFixed(2)}</td>
                          <td data-label='Retención'>{parseFloat(item.retencion).toFixed(2)}</td>
                        </tr>
                      ))
                    )
                  }
                </tbody>
              </table>
              {dataFile.length > 0 && (
                <Pagination
                  data={dataFile}
                  state={(items: Array<any>) => setCurrentItems(items)}
                  items={20}
                />
              )}
            </div>
            <div style={{display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginTop: '16px'}}>
              <button className="button w-auto" onClick={handleCrearLibro}>Confirmar datos</button>
            </div>
          </div>
        </BasicCardDocumentos>
      </div>
    </>
  )
}

export default TableDataCargadaCompras
